import { render, staticRenderFns } from "./show.pages.page.vue?vue&type=template&id=a894de98&"
import script from "./show.pages.page.vue?vue&type=script&lang=js&"
export * from "./show.pages.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports